import React from 'react';

import { styleConfigs } from '../../resources/styleConfigs';

interface ILockIconBlueProps extends React.SVGProps<SVGSVGElement> {
  width?: string | number;
  height?: string | number;
  testId?: string;
}

const LockIconBlue = (props: ILockIconBlueProps): JSX.Element => {
  const {
    width = styleConfigs.dimensions.width20,
    height = styleConfigs.dimensions.height20,
    testId = 'lock-icon-blue',
  } = props;

  return (
    <svg
      aria-hidden="true"
      focusable="false"
      data-testid={testId}
      width={width}
      height={height}
      viewBox="0 0 201 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M156.439 81.25H43.9395C37.0359 81.25 31.4395 86.8464 31.4395 93.75V181.25C31.4395 188.154 37.0359 193.75 43.9395 193.75H156.439C163.343 193.75 168.939 188.154 168.939 181.25V93.75C168.939 86.8464 163.343 81.25 156.439 81.25Z"
        stroke="currentColor"
        strokeWidth={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M56.4395 81.25V50C56.4395 38.3968 61.0488 27.2688 69.2535 19.0641C77.4582 10.8594 88.5862 6.25 100.189 6.25C111.793 6.25 122.921 10.8594 131.125 19.0641C139.33 27.2688 143.939 38.3968 143.939 50V81.25"
        stroke="currentColor"
        strokeWidth={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M72.0645 118.75C71.4464 118.75 70.8422 118.933 70.3283 119.277C69.8144 119.62 69.4139 120.108 69.1773 120.679C68.9408 121.25 68.8789 121.878 68.9995 122.485C69.1201 123.091 69.4177 123.648 69.8547 124.085C70.2918 124.522 70.8486 124.819 71.4548 124.94C72.061 125.061 72.6893 124.999 73.2603 124.762C73.8314 124.526 74.3194 124.125 74.6628 123.611C75.0062 123.097 75.1895 122.493 75.1895 121.875C75.1895 121.046 74.8602 120.251 74.2742 119.665C73.6881 119.079 72.8933 118.75 72.0645 118.75Z"
        stroke="currentColor"
        strokeWidth={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M100.189 118.75C99.5714 118.75 98.9672 118.933 98.4533 119.277C97.9394 119.62 97.5389 120.108 97.3023 120.679C97.0658 121.25 97.0039 121.878 97.1245 122.485C97.2451 123.091 97.5427 123.648 97.9797 124.085C98.4168 124.522 98.9736 124.819 99.5798 124.94C100.186 125.061 100.814 124.999 101.385 124.762C101.956 124.526 102.444 124.125 102.788 123.611C103.131 123.097 103.314 122.493 103.314 121.875C103.314 121.046 102.985 120.251 102.399 119.665C101.813 119.079 101.018 118.75 100.189 118.75Z"
        stroke="currentColor"
        strokeWidth={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M128.314 118.75C127.696 118.75 127.092 118.933 126.578 119.277C126.064 119.62 125.664 120.108 125.427 120.679C125.191 121.25 125.129 121.878 125.25 122.485C125.37 123.091 125.668 123.648 126.105 124.085C126.542 124.522 127.099 124.819 127.705 124.94C128.311 125.061 128.939 124.999 129.51 124.762C130.081 124.526 130.569 124.125 130.913 123.611C131.256 123.097 131.439 122.493 131.439 121.875C131.439 121.046 131.11 120.251 130.524 119.665C129.938 119.079 129.143 118.75 128.314 118.75Z"
        stroke="currentColor"
        strokeWidth={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M72.0645 150C71.4464 150 70.8422 150.183 70.3283 150.527C69.8144 150.87 69.4139 151.358 69.1773 151.929C68.9408 152.5 68.8789 153.128 68.9995 153.735C69.1201 154.341 69.4177 154.898 69.8547 155.335C70.2918 155.772 70.8486 156.069 71.4548 156.19C72.061 156.311 72.6893 156.249 73.2603 156.012C73.8314 155.776 74.3194 155.375 74.6628 154.861C75.0062 154.347 75.1895 153.743 75.1895 153.125C75.1895 152.296 74.8602 151.501 74.2742 150.915C73.6881 150.329 72.8933 150 72.0645 150Z"
        stroke="currentColor"
        strokeWidth={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M100.189 150C99.5714 150 98.9672 150.183 98.4533 150.527C97.9394 150.87 97.5389 151.358 97.3023 151.929C97.0658 152.5 97.0039 153.128 97.1245 153.735C97.2451 154.341 97.5427 154.898 97.9797 155.335C98.4168 155.772 98.9736 156.069 99.5798 156.19C100.186 156.311 100.814 156.249 101.385 156.012C101.956 155.776 102.444 155.375 102.788 154.861C103.131 154.347 103.314 153.743 103.314 153.125C103.314 152.296 102.985 151.501 102.399 150.915C101.813 150.329 101.018 150 100.189 150Z"
        stroke="currentColor"
        strokeWidth={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M128.314 150C127.696 150 127.092 150.183 126.578 150.527C126.064 150.87 125.664 151.358 125.427 151.929C125.191 152.5 125.129 153.128 125.25 153.735C125.37 154.341 125.668 154.898 126.105 155.335C126.542 155.772 127.099 156.069 127.705 156.19C128.311 156.311 128.939 156.249 129.51 156.012C130.081 155.776 130.569 155.375 130.913 154.861C131.256 154.347 131.439 153.743 131.439 153.125C131.439 152.296 131.11 151.501 130.524 150.915C129.938 150.329 129.143 150 128.314 150Z"
        stroke="currentColor"
        strokeWidth={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default LockIconBlue;
